module.exports = __webpack_public_path__ + "img/仅限货机.cd210b98.jpg";